import type { Task, TaskListItem } from "@myapp/contract";
import {
  buildDeleteDialogOptions,
  type RecordedWork,
} from "../../../shared/lib/deleteDialogOptions";
import type { DeleteDialogOptions } from "../../../shared/hooks/useDeleteDialog";

type TaskLike = Pick<Task | TaskListItem, "status" | "schedule" | "seriesId">;

/**
 * How far the work on an Aufgabe got — what deleting it would erase.
 *
 * The office may delete an Aufgabe in any state (`DeleteTaskUseCase` no longer refuses), so this is
 * not a gate: it only decides how loud the confirm dialog is. An unscheduled task has no `schedule`
 * at all and therefore nothing recorded.
 */
export const getTaskRecordedWork = (
  task: Pick<Task | TaskListItem, "status" | "schedule">,
): RecordedWork => {
  if (task.status === "COMPLETED") return "completed";
  return task.schedule?.actualWorkStartsAt != null ? "started" : null;
};

/** The options `useDeleteDialog.openDelete` takes for this Aufgabe — one place, every caller. */
export const getTaskDeleteDialogOptions = (task: TaskLike): DeleteDialogOptions =>
  buildDeleteDialogOptions({
    noun: "Aufgabe",
    recorded: getTaskRecordedWork(task),
    isSeries: task.seriesId != null,
  });
